<template>
    <header class="index-header">
        <img class="desktop" :src="index_banner" alt="">
        <img class="mobile" :src="index_banner_m" alt="">
        <div class="scroll-down-wrapper" @click="scrollDown('#brand-intro')">
            <img :src="scroll_down" alt="">
        </div>
    </header>
    
</template>
<script>




import index_banner from '../assets/index-banner.png';
import index_banner_m from '../assets/index-banner-m.jpg';
import scroll_down from '../assets/scroll-down.png'
import scrollTo from '../functions/scrollTo'



export default {
    data(){
        return {
            index_banner,
            index_banner_m,
            scroll_down
        }
    },
    computed: {
        // mask_style(){
        //     //mask-fade-out

        // }
    },
    methods: {
        scrollDown(el) {
            scrollTo(el, 1)
        }

    },
    updated(){
        //this.onYouTubePlayerAPIReady();
        //this.YTplay();
    },
    mounted(){
    },
    created(){
    }
}




</script>

<style lang="sass">

header.index-header
    position: relative
    img
        width: 100%
    .desktop
        @media (max-width: 768px)
            display: none
    .mobile
        display: none
        @media (max-width: 768px)
            display: block
    .scroll-down-wrapper
        position: absolute
        left: 0
        bottom: 4%
        width: 100%
        display: flex
        align-items: center
        justify-content: center
        padding: 0px 0
        img
            width: 3%
            min-width: 45px
            animation: 2s infinite scroll
        @media (max-width: 768px)
            background-color: #070506
            position: static
            padding: 40px 0
            padding-top: 30px
            img
                min-width: auto
                width: 45px
        @media (max-width: 576px)
            padding-top: 20px

@keyframes scroll
    0%
        opacity: 1
        transform: translateY(0)

    100%
        opacity: 0
        transform: translateY(20px)


    

        
</style>



// WEBPACK FOOTER //
// src/Index/Header.vue